<template>
    <div>
        <div
            v-if="isMenuExpanded || (isAccountExpanded && isSignedIn)"
            class="mobile-navbar__backdrop"
            @click="onCloseClick"
        />
        <header class="header mobile-header header--fixed">
            <nav class="mobile-navbar">
                <div class="flex__align-center">
                    <div class="navbar__menu-icon">
                        <i
                            v-if="isMenuExpanded"
                            class="icon icon-close"
                            @click="onCloseClick"
                        />
                        <i
                            v-else
                            class="icon icon-menu"
                            @click="onHamburgerClick"
                        />
                    </div>
                    <router-link :to="links.landing" class="navbar__link navbar__logo">
                        <img src="/static/img/logo.svg" class="mobile-navbar__logo" alt="Superbet"/>
                    </router-link>
                </div>
                <div class="header__right">
                    <button
                        v-if="!isSignedIn"
                        @click="$emit('loginClick')"
                        class="btn btn--md btn__primary--yellow mobile-header__btn"
                    >
                        {{ $t('login') | capitalize }}
                    </button>
                    <template v-else>
                        <AccountContainer
                            :isExpanded="isAccountExpanded"
                            @profileClick="onProfileClick"
                        />
                        <router-link
                            v-if="$route.name !== routes.deposit.name"
                            :to="routes.deposit"
                            tag="button"
                            class="btn btn--md btn--w-144 btn__primary--yellow"
                        >
                            {{ $t('deposit') | capitalize }}
                        </router-link>
                    </template>
                </div>
            </nav>
            <ul
                v-if="isMenuExpanded"
                class="mobile-navbar__menu"
                :class="{'is-expanded': isMenuExpanded }"
            >
                <li class="mobile-navbar__menu-item">
                    <router-link
                        @click.native="onPageClick"
                        :to="links.landing"
                        :class="{ 'is-active': isOnSportsPage }"
                        class="mobile-navbar__link"
                    >
                        {{ $t('sport') }}
                    </router-link>
                </li>
                <li class="mobile-navbar__menu-item">
                    <router-link
                        @click.native="onPageClick"
                        :to="routes.live"
                        class="mobile-navbar__link"
                        :class="{ 'is-active': isOnSportLivePage }"
                    >
                        <span
                            class="navbar__live-events-count"
                        >
                            {{ liveEventsCount }}
                        </span>
                        {{ $t('live') }}
                    </router-link>
                </li>
                <li class="mobile-navbar__menu-item">
                    <router-link
                        @click.native="onPageClick"
                        :to="links.games"
                        class="mobile-navbar__link"
                        activeClass="is-active"
                    >
                        {{ $t('games') }}
                    </router-link>
                </li>
                <li class="mobile-navbar__menu-item">
                    <router-link
                        @click.native="onPageClick"
                        :to="links.casino"
                        class="mobile-navbar__link"
                        activeClass="is-active"
                    >
                        {{ $t('casino live') }}
                    </router-link>
                </li>
                <li class="mobile-navbar__menu-item">
                    <router-link
                        @click.native="onPageClick"
                        :to="links.lottery"
                        class="mobile-navbar__link"
                        activeClass="is-active"
                    >
                        {{ $t('lottery') }}
                    </router-link>
                </li>
                <li class="mobile-navbar__menu-item">
                    <router-link
                        @click.native="onPageClick"
                        :to="links.virtual"
                        class="mobile-navbar__link"
                        activeClass="is-active"
                    >
                        {{ $t('virtual') }}
                    </router-link>
                </li>
                <li class="mobile-navbar__menu-item">
                    <router-link
                        @click.native="onPageClick"
                        :to="routes.results"
                        class="mobile-navbar__link"
                        :class="{ 'is-active': isOnResultsPage }"
                        activeClass="is-active"
                    >
                        {{ $t('results') }}
                    </router-link>
                </li>
                <li class="mobile-navbar__menu-item">
                    <router-link
                        @click.native="onPageClick"
                        :to="links.news"
                        class="mobile-navbar__link"
                        activeClass="is-active"
                    >
                        {{ $t('news') }}
                    </router-link>
                </li>
                <li class="mobile-navbar__menu-item">
                    <router-link
                        @click.native="onPageClick"
                        :to="routes.promotions"
                        class="mobile-navbar__link"
                        activeClass="is-active"
                    >
                        {{ $t('bonuses promotions') }}
                    </router-link>
                </li>
                <li class="mobile-navbar__divider"></li>
                <li class="mobile-navbar__menu-item">
                    <router-link
                        @click.native="onPageClick"
                        :to="links.verifyTicket"
                        class="mobile-navbar__link"
                        activeClass="is-active"
                    >
                        {{$t('check ticket')}}
                    </router-link>
                </li>
                <li class="mobile-navbar__menu-item">
                    <router-link
                        @click.native="onPageClick"
                        :to="links.shops"
                        class="mobile-navbar__link"
                        activeClass="is-active"
                    >
                        {{$t('shops')}}
                    </router-link>
                </li>
                <li class="mobile-navbar__menu-item">
                    <router-link
                        @click.native="onPageClick"
                        :to="links.help"
                        class="mobile-navbar__link"
                        activeClass="is-active"
                    >
                        {{ $t('help') | upperCase }}
                    </router-link>
                </li>
            </ul>
        </header>
    </div>
</template>


<script>
    import { mapGetters, mapActions } from 'vuex';
    import { routeNames, links } from '@app/router';
    import config from '@config';
    import { liveTimeFilterSlug } from '@store/modules/ui/shared/timeFilter/utils';
    import AccountContainer from '@app/shared/components/Account/AccountContainer';
    import { SidebarId } from '@app/store/modules/ui/mobile/enums';

    export default {
        name: 'Header',
        props: {
            liveEventsCount: {
                type: Number,
                required: true
            },
            isOnSportLivePage: {
                type: Boolean,
                required: true
            },
            isOnSportsPage: {
                type: Boolean,
                required: true
            },
            isOnResultsPage: {
                type: Boolean,
                required: true
            },
            isSignedIn: {
                type: Boolean,
                required: true,
            },
        },
        watch: {
            isSignedIn(val) {
                if (val) {
                    this.onCloseClick();
                }
            }
        },
        created() {
            this.links = links;
            this.appVersion = config.environment.version;
            this.routes = {
                live: {
                    name: routeNames.sportOffer,
                    params: {
                        timeFilter: liveTimeFilterSlug,
                    },
                },
                results: {
                    name: routeNames.sportResults,
                },
                deposit: {
                    name: routeNames.deposit,
                },
                promotions: {
                    name: routeNames.promotionsInfo,
                }
            };
            this.accountMenuId = 'account';
        },
        computed: {
            ...mapGetters('ui/mobile', ['isSidebarOpen']),
            isMenuExpanded() {
                return this.isSidebarOpen(SidebarId.mainNabvbar);
            },
            isAccountExpanded() {
                return this.isSidebarOpen(SidebarId.accountMenu);
            }
        },
        methods: {
            ...mapActions('ui/mobile', [
                'toggleSidebar',
                'closeSidebar',
            ]),
            onPageClick(event) {
                this.$emit('pageClick', event.target.pathname);
                this.closeSidebar();
            },
            onHamburgerClick() {
                this.toggleSidebar(SidebarId.mainNabvbar);
            },
            onProfileClick() {
                this.toggleSidebar(SidebarId.accountMenu);
            },
            onCloseClick() {
                this.closeSidebar();
            },
        },
        components: {
            AccountContainer,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/mobile/components/MobileNavbar.vue